module.exports = __webpack_public_path__ + "img/WindPowerTower.83ca63a0.jpg";